import { render, staticRenderFns } from "./PaxelinMarket.vue?vue&type=template&id=168ba325&"
import script from "./PaxelinMarket.vue?vue&type=script&lang=js&"
export * from "./PaxelinMarket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports